<div class="grid">
  <div class="col-6">
    <a class="logo-container" href="https://www.iotsens.com" target="_blank">
      <img alt="iotsens" src="/assets/logo/logo-collapsed.png">
    </a>
  </div>
  <div class="col-6 footer-icons">
    <a href="https://www.facebook.com/iotsens/" target="_blank"><i class="pi pi-facebook"></i></a>
  </div>
</div>
